import { render } from "./Popup.vue?vue&type=template&id=2022e004&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=2022e004&lang=css"
import "./Popup.vue?vue&type=style&index=1&id=2022e004&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2022e004"]])

export default __exports__